// The URL of the app's built entry module. Vite bundles it as a separate chunk;
// nothing from the app's module graph enters the shell's bundle (§8).
//
// It is a URL, not a spawn closure, on purpose: a URL is all `IframeHost` will
// be able to use once apps move to their own origins (§4.4).
import filesEntry from "@gelatos/demo-files/app?worker&url";
import notesEntry from "@gelatos/demo-notes/app?worker&url";
import counterEntry from "@gelatos/demo-counter/app?worker&url";
import terminalEntry from "@gelatos/demo-terminal/app?worker&url";
import type { AppSource } from "./AppHost.js";

/** Which of the three app tiers in §4.4 an app belongs to. */
export type AppTier = 1 | 2 | 3;

export type AppDescriptor = {
  id: string;
  name: string;
  icon: string;
  tier: AppTier;
  defaultSize: { w: number; h: number };
  source: AppSource;
};

/**
 * What the shell knows about launchable apps.
 *
 * Note what is *not* here: any import of app code, and any statement about how
 * an app is isolated. App discovery and installation are out of scope (§2), so
 * the table is static.
 */
export const APPS: readonly AppDescriptor[] = [
  {
    id: "demo-counter",
    name: "Counter",
    icon: "app",
    tier: 1,
    defaultSize: { w: 300, h: 190 },
    source: { kind: "module", url: counterEntry },
  },
  {
    id: "demo-files",
    name: "Files",
    icon: "folder",
    tier: 1,
    defaultSize: { w: 340, h: 320 },
    source: { kind: "module", url: filesEntry },
  },
  {
    id: "demo-terminal",
    name: "Terminal",
    icon: "terminal",
    tier: 1,
    defaultSize: { w: 560, h: 360 },
    source: { kind: "module", url: terminalEntry },
  },
  {
    id: "demo-notes",
    name: "Notes",
    icon: "note",
    tier: 1,
    defaultSize: { w: 400, h: 320 },
    source: { kind: "module", url: notesEntry },
  },
];

export function findApp(id: string): AppDescriptor | undefined {
  return APPS.find((app) => app.id === id);
}
